import { categoryField } from "../fragments/categories"

export const getCategoryQuery = /* GraphQL */ `
    query getCategory($entityId: Int!) {
        site {
            category(entityId: $entityId) {
                entityId
                name
                path
                description
                seo {
                    metaDescription
                    metaKeywords
                    pageTitle
                }
            }
        }
    }
`

export const getStoreCategorieTreeQuery = /* GraphQL */ `
    query CategoryTree4LevelsDeep {
        site {
            categoryTree {
                ...CategoryFields
                children {
                    ...CategoryFields
                    children {
                        ...CategoryFields
                        children {
                            ...CategoryFields
                        }
                    }
                }
            }
        }
    }
    ${categoryField}
`
